export const MAX_GPX_BYTES = 10 * 1024 * 1024;

export function readFileAsText(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result);
    reader.onerror = reject;
    reader.readAsText(file);
  });
}

export function haversine(a, b) {
  const earthRadiusKm = 6371;
  const dLat = toRadians(b.latitude - a.latitude);
  const dLon = toRadians(b.longitude - a.longitude);
  const lat1 = toRadians(a.latitude);
  const lat2 = toRadians(b.latitude);
  const h = Math.sin(dLat / 2) ** 2 + Math.cos(lat1) * Math.cos(lat2) * Math.sin(dLon / 2) ** 2;

  return 2 * earthRadiusKm * Math.asin(Math.sqrt(h));
}

export function getSpeedColor(speed, minSpeed, maxSpeed) {
  const range = maxSpeed - minSpeed;
  const ratio = range > 0.001 ? clamp((speed - minSpeed) / range, 0, 1) : 0.5;
  const hue = Math.round(ratio * 120);

  return `hsl(${hue}, 88%, 46%)`;
}

export function percentile(values, percent) {
  const sorted = values.slice().sort((a, b) => a - b);
  if (!sorted.length) {
    return 0;
  }

  const index = (sorted.length - 1) * percent;
  const lower = Math.floor(index);
  const upper = Math.ceil(index);

  if (lower === upper) {
    return sorted[lower];
  }

  return sorted[lower] + (sorted[upper] - sorted[lower]) * (index - lower);
}

export function formatSpeed(value) {
  return `${round(value)} km/h`;
}

export function formatDistance(value) {
  return Number.isInteger(value) ? String(value) : value.toFixed(1);
}

function round(value) {
  return Math.round(value * 10) / 10;
}

function toRadians(value) {
  return value * Math.PI / 180;
}

function clamp(value, min, max) {
  return Math.max(min, Math.min(max, value));
}
